import React from "react";
import PVReviewIndex from "../../sub-treasury/pv-collection/PVReviewIndex";

const MdaCheckPV = () => {
  return <PVReviewIndex mdaType="self-sustaining" mode="check" />;
};
export default MdaCheckPV;
